module.exports = __webpack_public_path__ + "img/bg1.8b11874d.png";